//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LoanOrderDiscount',
  data() {
    return {
      detail: {},
      applyDiscountData: [], // 申请贴息资料
      applyCashData: [], //申请兑现资料
      statusRecords: [], // 状态步骤数据
      cashData: [], // 兑现信息
      active: 1,
      applyNum: '',
      applyTime: '',
      loading: false,
    }
  },
  computed: {
    showApplyDiscount() {
      return this.detail.status !== 'NS9902'
    },
    showApplyCash() {
      return ['NS06', 'NS04', 'NS07'].includes(this.detail.status)
    },
    showApplyCashed() {
      return this.detail.status === 'NS07'
    },
  },
  mounted() {
    this.id = this.$route.query.id
    this.applyNum = this.$route.query.applyNum
    this.applyTime = this.$route.query.applyTime
    this.getDiscountDetailById()
  },
  methods: {
    /**
     * @description: 获取订单贴息详情
     * @Author: quwandong
     * @Date: 2022-05-18 10:21:21
     */
    async getDiscountDetailById() {
      try {
        this.loading = true
        const res = await this.$http.loanOrder.getDiscountDetailById({
          applyId: this.id,
        })
        if (res.status == 1) {
          this.detail = res.data.data
          this.applyDiscountData = [
            {
              disburseAmount: this.detail.disburseAmount || 0,
              disburseDuration: this.detail.disburseDuration || 0,
              yearRatio: this.detail.yearRatio || 0,
              repaymentType: this.detail.repaymentType || 0,
            },
          ]
          this.applyCashData = [
            {
              loanDate: this.detail.loanDate,
              settleDate: this.detail.settleDate,
              actualUseDays: this.detail.actualUseDays || 0,
              exSubsidyAmount: this.detail.exSubsidyAmount || 0,
            },
          ]

          this.statusRecords = this.detail.statusRecords

          this.active = this.detail.statusRecords.length

          this.cashData = [
            {
              paidTime:
                this.statusRecords.length > 0
                  ? this.statusRecords[0].paidTime
                  : '',
              exSubsidyAmount: this.detail.exSubsidyAmount || 0,
            },
          ]
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    /**
     * @description: 获取 状态步骤的icon
     * @param status
     * @Author: quwandong
     * @Date: 2022-05-19 10:34:42
     */
    getStatusIcon(status) {
      const target = this.statusRecords.findIndex(
        (item) => status === item.status
      )
      return target > -1 ? 'el-icon-success' : ''
    },
    /**
     * @description: 获取 状态步骤的time
     * @param status
     * @Author: quwandong
     * @Date: 2022-05-19 10:34:42
     */
    getStatusTime(status) {
      const target = this.statusRecords.find((item) => status === item.status)
      return target ? target.time : ''
    },
    /**
     * @description: 获取 状态步骤的remark
     * @param status
     * @Author: quwandong
     * @Date: 2022-05-19 10:34:42
     */
    getStatusRemark(status) {
      const target = this.statusRecords.find((item) => status === item.status)
      return target ? target.remark : ''
    },
  },
}
